<template>
  <div class="digido-form-viewer">
    <formio :form="schema" :submission="{data: value}" :options="options" @submit="submitHandler"></formio>
  </div>
</template>

<script>
import { Form } from 'vue-formio'

export default {
  name: 'FormViewer',
  components: { Formio: Form },
  methods: {
    submitHandler (submission) {
      return this.onSubmit(submission.data).then(() => {
        this.$emit('submitDone', submission)
      }).catch(() => {
        this.$emit('submitError', submission)
      })
    }
  },
  computed: {
    options () {
      return {
        readOnly: this.readOnly,
        //viewAsHtml: this.readOnly,
        nosubmit: true
      }
    }
  },
  props: {
    schema: {
      type: Object,
      required: true
    },
    value: {
      type: Object
    },
    formId: {
      required: true
    },
    onSubmit: {},
    readOnly: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
  .digido-form-viewer {
    @import "~formiojs/dist/formio.form.css";

    .signature-pad-body {
      height: 150px !important;
    }

    .well, .formio-form dd {
      min-height: 20px;
      padding: 19px;
      margin-bottom: 20px;
      background-color: #f5f5f5;
      border: 1px solid #e3e3e3;
      border-radius: 4px;
      -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .05);
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, .05);
    }

    .formio-component-submit {
      .submit-success::after {
        font-family: 'Font Awesome\ 5 Free';
        content: '\f058';
        position: relative;
        right: -4px;
        top: 1;
        line-height: 1;
      }

      .submit-fail::after {
        font-family: 'Font Awesome\ 5 Free';
        content: '\f057';
        position: relative;
        right: -4px;
        top: 1;
        line-height: 1;
      }
    }

  }

  .formio-component-file .fileSelector {
    padding: 15px;
    border: 2px dashed #ddd;
    text-align: center;
  }
</style>